module.exports = __webpack_public_path__ + "static/media/michael-flynn.aa7645a3.jpg";